// extracted by mini-css-extract-plugin
export default {"button":"FavoriteToggleButton_button__FM6Bk","plus":"FavoriteToggleButton_plus__Eou-j","words":"FavoriteToggleButton_words__fYIKy"};